import * as React from 'react'
import { Section } from '../section'
import { styles } from './styles.css'
import { FaqCard } from '../faq-card'
import { Flex } from '@radix-ui/themes'

export const FaqSection: React.FC = () => {
  return (
    <Section id="faq" title="FAQ" subtitle="よくあるご質問" className={styles.section}>
      <Flex direction="column" align="start" justify="start" width="100%" gap="24px" px="24px">
        <FaqCard
          question="ボリュームはどのくらいですか？"
          answer="花とグリーン合わせて約12本入りなので、ダイニングテーブルや玄関に飾って華やかに見えるボリューム感です。"
        />
        <FaqCard
          question="お届け日は指定できますか？"
          answer="品質を担保するためお花にとってベストなタイミングで発送しております。発送後、クロネコヤマトのアプリなどで受け取りタイミングをずらすことは可能です。"
        />
        <FaqCard
          question="平日に受け取ることはできますか？"
          answer="ただいまFLOWERの定期便は金曜日に発送を行っており、到着日は土曜日もしくは日曜日となります（配送エリアによって変わります）。そのため、現状は週末受け取りのみ対応となっております🙇‍♂️"
        />
        <FaqCard
          question="夏でも元気なお花が届きますか？"
          answer="はい。FLOWERでは気温が25度を超える期間はクール便を利用し、品質を保ちながらお届けしております。追加料金はかかりませんのでご安心ください。"
        />
        <FaqCard question="届いたお花が枯れていたら？" answer="お問い合わせまでお気軽にご連絡ください。返金または代品にて補償が可能です。" />
        <FaqCard question="お試しだけでもいいですか？" answer="はい。初回で停止していただくことも可能です。まずは一度、お試しください☺️" />
        <FaqCard
          question="スキップや解約はできますか？"
          answer="はい。FLOWERの定期便はいつでもスキップ・解約が可能です。次回発送の3日前の正午までにお手続きください。"
        />
      </Flex>
    </Section>
  )
}
